import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth }   from '../context/AuthContext';
import { useEquipo } from '../context/EquipoContext';

const COLORES_PRESET = [
  ['#FF6B1A', '#1A6BFF'],
  ['#EF4444', '#0D1117'],
  ['#16A34A', '#FACC15'],
  ['#7C3AED', '#EC4899'],
  ['#1A6BFF', '#0D1117'],
  ['#F59E0B', '#EF4444'],
  ['#0891B2', '#16A34A'],
  ['#DC2626', '#1D4ED8'],
];

const MODALIDADES_FUTBOL = [
  { id: 'futbol5',  label: 'Fútbol 5'     },
  { id: 'futbol7',  label: 'Fútbol 7'     },
  { id: 'futbol11', label: 'Fútbol 11'    },
  { id: 'futsal',   label: 'Futsal'       },
  { id: 'playa',    label: 'Fútbol playa' },
];

const MODALIDADES_RAQUETA = [
  { id: 'individual', label: 'Individual' },
  { id: 'dobles',     label: 'Dobles'     },
];

const DEPORTES = [
  { id: 'futbol', label: '⚽ Fútbol',  desc: 'Equipos de hasta 11 jugadores' },
  { id: 'padel',  label: '🎾 Pádel',   desc: 'Individual o dobles' },
  { id: 'tenis',  label: '🎾 Tenis',   desc: 'Individual o dobles' },
];

const ZONAS = [
  'Machalí', 'Rancagua', 'Sewell', 'Graneros',
  'Mostazal', 'Coinco', 'Coltauco', 'Doñihue',
  'Las Cabras', 'Peumo', 'Pichidegua', 'San Vicente',
];

const PLANES = [
  {
    id: 'free',
    nombre: 'Free',
    precio: '$0',
    periodo: 'siempre gratis',
    color: '#9BA5B7',
    beneficios: [
      'Hasta 3 desafíos por mes',
      'Perfil público del equipo',
      'Sistema ELO y evaluaciones',
    ],
  },
  {
    id: 'pro',
    nombre: 'Pro',
    precio: '$4.990',
    periodo: 'por mes',
    color: '#1A6BFF',
    destacado: true,
    beneficios: [
      'Desafíos ilimitados',
      'Prioridad en el matchmaking',
      'Estadísticas avanzadas',
    ],
  },
  {
    id: 'club',
    nombre: 'Club',
    precio: '$9.990',
    periodo: 'por mes',
    color: '#FF6B1A',
    beneficios: [
      'Todo lo del plan Pro',
      'Hasta 3 equipos por cuenta',
      'Badge Club en el perfil',
    ],
  },
];

export default function CrearEquipo() {
  const navigate                           = useNavigate();
  const { user, token }                    = useAuth();
  const { registrarEquipo, equipo: equipoActual, deporteActivo } = useEquipo();

  const [paso,     setPaso]     = useState(1);
  const [cargando, setCargando] = useState(false);
  const [error,    setError]    = useState('');

  const [deporte,         setDeporte]         = useState(deporteActivo || 'futbol');
  const [nombre,          setNombre]          = useState('');
  const [colorPrincipal,  setColorPrincipal]  = useState('#FF6B1A');
  const [colorSecundario, setColorSecundario] = useState('#1A6BFF');
  const [modalidades,     setModalidades]     = useState([]);
  const [zonas,           setZonas]           = useState([]);
  const [plan,            setPlan]            = useState('free');
  const [celular,         setCelular]         = useState(user?.celular || '');
  const [edad,            setEdad]            = useState('');

  const esFutbol = deporte === 'futbol';

  const iniciales = nombre
    .split(' ').filter(p => p.length > 0).slice(0, 2)
    .map(p => p[0].toUpperCase()).join('') || 'EQ';

  const toggleModalidad = (id) => {
    setModalidades(prev =>
      prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]
    );
  };

  const toggleZona = (z) => {
    setZonas(prev =>
      prev.includes(z) ? prev.filter(x => x !== z) : [...prev, z]
    );
  };

  const handlePaso1 = () => {
    if (!nombre.trim()) { setError('El nombre es obligatorio'); return; }
    if (!celular.trim()) { setError('El WhatsApp es obligatorio'); return; }
    if (!esFutbol && !edad) { setError('La edad es obligatoria para pádel/tenis'); return; }
    setError('');
    setPaso(2);
  };

  const handlePaso2 = () => {
    if (modalidades.length === 0) { setError('Selecciona al menos una modalidad'); return; }
    if (zonas.length === 0) { setError('Selecciona al menos una zona'); return; }
    setError('');
    setPaso(3);
  };

  const handleFinalizar = async () => {
    setCargando(true);
    setError('');
    try {
      const urlNombre = nombre
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-') + '-' + Date.now();

      const ok = await registrarEquipo({
        nombre,
        url_nombre:       urlNombre,
        color_principal:  colorPrincipal,
        color_secundario: colorSecundario,
        zona:             zonas.join(', '),
        region:           "O'Higgins",
        modalidades,
        dias:             [],
        horarios:         [],
        plan,
        capitan_id:       user?.id,
        deporte,
      }, token);

      if (!ok) { setError('Error al crear el equipo. Intenta de nuevo.'); setCargando(false); return; }

      // Guardar celular y edad en usuarios — aplica a todos los deportes
      if (celular.trim() || edad) {
        await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/usuarios/${user?.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            celular: celular.trim() || undefined,
            edad:    edad ? parseInt(edad) : undefined,
          }),
        });
      }
      navigate('/app/nomina');
    } catch {
      setError('Error de conexión');
    } finally {
      setCargando(false);
    }
  };

  const labelNombre = esFutbol ? 'Nombre del equipo' : 'Nombre o apodo';
  const placeholderNombre = esFutbol ? 'Ej: Los Bombarderos FC' : 'Ej: Pedro Salfatte';

  return (
    <div style={styles.pagina}>
      <div style={styles.container}>

        <div style={styles.header}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.headerTitulo}>
            {esFutbol
              ? (equipoActual ? 'Crear otro equipo' : 'Registrar mi equipo')
              : (equipoActual ? 'Crear otro perfil' : 'Registrar mi perfil')}
          </div>
          <div style={styles.headerSub}>
            {user?.nombre} · Paso {paso} de 3
          </div>
        </div>

        <div style={styles.stepper}>
          {['Identidad', 'Modalidad', 'Plan'].map((label, i) => {
            const num        = i + 1;
            const completado = paso > num;
            const activo     = paso === num;
            return (
              <div key={num} style={styles.stepItem}>
                <div style={{
                  ...styles.stepCirculo,
                  background: completado ? '#16A34A' : activo ? '#FF6B1A' : '#E8ECF4',
                }}>
                  <span style={{
                    color: completado || activo ? 'white' : '#9BA5B7',
                    fontSize: 13, fontWeight: 700,
                    fontFamily: "'Barlow Condensed', sans-serif",
                  }}>
                    {completado ? '✓' : num}
                  </span>
                </div>
                <span style={{
                  fontSize: 11, fontWeight: 600,
                  color: activo ? '#141922' : '#9BA5B7',
                  fontFamily: "'Barlow', sans-serif",
                  textTransform: 'uppercase', letterSpacing: '0.04em',
                }}>
                  {label}
                </span>
                {i < 2 && (
                  <div style={{
                    ...styles.stepLinea,
                    background: completado ? '#16A34A' : '#E8ECF4',
                  }} />
                )}
              </div>
            );
          })}
        </div>

        <div style={styles.card}>
          {error && <div style={styles.errorBanner}>{error}</div>}

          {/* PASO 1 */}
          {paso === 1 && (
            <div>
              <div style={styles.pasoTitulo}>
                {esFutbol ? '¿Cómo se llama tu equipo?' : '¿Cuál es tu nombre o apodo?'}
              </div>
              <div style={styles.pasoSub}>
                {esFutbol
                  ? 'El nombre y los colores son la identidad de tu equipo.'
                  : 'Este será tu nombre en TuRival para pádel/tenis.'}
              </div>

              {/* Selector deporte */}
              <div style={styles.campo}>
                <div style={styles.label}>Deporte</div>
                <div style={{ display: 'grid', gridTemplateColumns: `repeat(${deporteActivo && deporteActivo !== 'futbol' ? 1 : 3}, 1fr)`, gap: 8, marginBottom: 4 }}>
                  {DEPORTES.filter(d => !deporteActivo || deporteActivo === 'futbol' ? true : d.id === deporteActivo).map(d => (
                    <div
                      key={d.id}
                      onClick={() => { if (!deporteActivo || deporteActivo === 'futbol') { setDeporte(d.id); setModalidades([]); setError(''); } }}
                      style={{
                        borderRadius: 10, padding: '10px 8px', textAlign: 'center',
                        cursor: deporteActivo && deporteActivo !== 'futbol' ? 'default' : 'pointer',
                        transition: 'all 0.12s',
                        border: `2px solid ${deporte === d.id ? '#FF6B1A' : '#E8ECF4'}`,
                        background: deporte === d.id ? '#FFF7ED' : 'white',
                      }}
                    >
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, color: deporte === d.id ? '#FF6B1A' : '#141922', marginBottom: 3 }}>
                        {d.label}
                      </div>
                      <div style={{ fontSize: 10, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>{d.desc}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={styles.previewWrap}>
                <div style={{
                  ...styles.previewEscudo,
                  background: `linear-gradient(135deg, ${colorPrincipal}, ${colorSecundario})`,
                }}>
                  {iniciales}
                </div>
                <div style={styles.previewNombre}>
                  {nombre || labelNombre}
                </div>
              </div>

              <div style={styles.campo}>
                <div style={styles.label}>{labelNombre}</div>
                <input
                  style={styles.input}
                  value={nombre}
                  onChange={e => { setNombre(e.target.value); setError(''); }}
                  placeholder={placeholderNombre}
                  maxLength={40}
                />
              </div>

              {/* Celular — obligatorio para todos. Edad — obligatoria solo para pádel/tenis */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={styles.campo}>
                  <div style={styles.label}>🟢 WhatsApp *</div>
                  <input
                    style={styles.input}
                    value={celular}
                    onChange={e => { setCelular(e.target.value); setError(''); }}
                    placeholder="+56 9 1234 5678"
                    type="tel"
                  />
                </div>
                <div style={styles.campo}>
                  <div style={styles.label}>Edad{!esFutbol ? ' *' : ''}</div>
                  <input
                    style={styles.input}
                    value={edad}
                    onChange={e => { setEdad(e.target.value); setError(''); }}
                    placeholder="Ej: 28"
                    type="number"
                    min="10" max="80"
                  />
                </div>
              </div>
              <div style={{ fontSize: 11, color: '#9BA5B7', marginTop: -10, marginBottom: 18, fontFamily: "'Barlow', sans-serif" }}>
                Acá te llegan los avisos de desafíos, recordatorios y pagos.
              </div>

              {esFutbol && <div style={styles.campo}>
                <div style={styles.label}>Colores</div>
                <div style={styles.coloresGrid}>
                  {COLORES_PRESET.map(([c1, c2], i) => (
                    <div
                      key={i}
                      onClick={() => { setColorPrincipal(c1); setColorSecundario(c2); }}
                      style={{
                        ...styles.colorPreset,
                        background: `linear-gradient(135deg, ${c1}, ${c2})`,
                        border: colorPrincipal === c1 && colorSecundario === c2
                          ? '3px solid #FF6B1A'
                          : '3px solid transparent',
                      }}
                    />
                  ))}
                </div>
              </div>}

              {esFutbol && <div style={styles.coloresCustomRow}>
                <div style={{ flex: 1 }}>
                  <div style={styles.labelSmall}>Color principal</div>
                  <div style={styles.colorPickerRow}>
                    <input type="color" value={colorPrincipal} onChange={e => setColorPrincipal(e.target.value)} style={styles.colorPicker} />
                    <span style={styles.colorHex}>{colorPrincipal}</span>
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={styles.labelSmall}>Color secundario</div>
                  <div style={styles.colorPickerRow}>
                    <input type="color" value={colorSecundario} onChange={e => setColorSecundario(e.target.value)} style={styles.colorPicker} />
                    <span style={styles.colorHex}>{colorSecundario}</span>
                  </div>
                </div>
              </div>}

              <button style={styles.btnSiguiente} onClick={handlePaso1}>
                Siguiente →
              </button>
            </div>
          )}

          {/* PASO 2 */}
          {paso === 2 && (
            <div>
              <div style={styles.pasoTitulo}>
                {esFutbol ? '¿Dónde y cómo juegan?' : '¿Cómo juegas?'}
              </div>
              <div style={styles.pasoSub}>
                {esFutbol
                  ? 'Selecciona las modalidades y las zonas donde juega tu equipo.'
                  : 'Selecciona si juegas individual, dobles o ambos.'}
              </div>

              <div style={styles.campo}>
                <div style={styles.label}>Modalidades</div>
                <div style={styles.modalidadesGrid}>
                  {(esFutbol ? MODALIDADES_FUTBOL : MODALIDADES_RAQUETA).map(m => (
                    <div
                      key={m.id}
                      onClick={() => { toggleModalidad(m.id); setError(''); }}
                      style={{
                        ...styles.modalidadBtn,
                        background: modalidades.includes(m.id) ? '#FF6B1A' : '#F4F6FA',
                        color:      modalidades.includes(m.id) ? 'white'   : '#4A5568',
                        border:     `1.5px solid ${modalidades.includes(m.id) ? '#FF6B1A' : '#E8ECF4'}`,
                      }}
                    >
                      {m.label}
                    </div>
                  ))}
                </div>
              </div>

              <div style={styles.campo}>
                <div style={styles.label}>Zonas — selecciona todas donde juegas</div>
                <div style={styles.zonasGrid}>
                  {ZONAS.map(z => (
                    <div
                      key={z}
                      onClick={() => { toggleZona(z); setError(''); }}
                      style={{
                        ...styles.zonaBtn,
                        background: zonas.includes(z) ? '#0D1117' : '#F4F6FA',
                        color:      zonas.includes(z) ? 'white'   : '#4A5568',
                        border:     `1.5px solid ${zonas.includes(z) ? '#0D1117' : '#E8ECF4'}`,
                      }}
                    >
                      {z}
                    </div>
                  ))}
                </div>
              </div>

              <div style={styles.botones}>
                <button style={styles.btnVolver} onClick={() => { setPaso(1); setError(''); }}>← Volver</button>
                <button style={styles.btnSiguiente} onClick={handlePaso2}>Siguiente →</button>
              </div>
            </div>
          )}

          {/* PASO 3 */}
          {paso === 3 && (
            <div>
              <div style={styles.pasoTitulo}>Elige tu plan</div>
              <div style={styles.pasoSub}>Puedes cambiar de plan en cualquier momento.</div>

              <div style={styles.planesGrid}>
                {PLANES.map(p => (
                  <div
                    key={p.id}
                    onClick={() => setPlan(p.id)}
                    style={{
                      ...styles.planCard,
                      border:     `2px solid ${plan === p.id ? p.color : '#E8ECF4'}`,
                      background: plan === p.id ? p.color + '15' : 'white',
                    }}
                  >
                    {p.destacado && (
                      <div style={{ ...styles.destacadoBadge, background: p.color }}>
                        Más popular
                      </div>
                    )}
                    <div style={{ ...styles.planNombre, color: p.color }}>{p.nombre}</div>
                    <div style={styles.planPrecio}>
                      {p.precio}<span style={styles.planPeriodo}> / {p.periodo}</span>
                    </div>
                    {p.beneficios.map(b => (
                      <div key={b} style={styles.beneficio}>
                        <span style={{ color: p.color, marginRight: 6 }}>✓</span>{b}
                      </div>
                    ))}
                    {plan === p.id && (
                      <div style={{ ...styles.seleccionadoBadge, background: p.color }}>
                        Seleccionado
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div style={styles.botones}>
                <button style={styles.btnVolver} onClick={() => { setPaso(2); setError(''); }}>← Volver</button>
                <button
                  style={{ ...styles.btnFinalizar, opacity: cargando ? 0.7 : 1 }}
                  onClick={handleFinalizar}
                  disabled={cargando}
                >
                  {cargando ? 'Creando...' : '⚡ Crear equipo'}
                </button>
              </div>
            </div>
          )}

        </div>

        {equipoActual && (
          <div style={styles.linkVolver} onClick={() => navigate('/app/dashboard')}>
            ← Volver al dashboard
          </div>
        )}

      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA', padding: '32px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
  container: { width: '100%', maxWidth: 580 },
  header: { textAlign: 'center', marginBottom: 24 },
  logo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 28, fontWeight: 800, color: '#141922', marginBottom: 4 },
  naranja: { color: '#FF6B1A' },
  headerTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: '#141922', marginBottom: 4 },
  headerSub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  stepper: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginBottom: 20 },
  stepItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, position: 'relative', flex: 1 },
  stepCirculo: { width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 },
  stepLinea: { position: 'absolute', top: 16, left: '50%', width: '100%', height: 2, zIndex: 0 },
  card: { background: 'white', border: '1px solid #E8ECF4', borderRadius: 20, padding: '28px 32px' },
  errorBanner: { background: 'rgba(239,68,68,0.1)', border: '1px solid #FCA5A5', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#EF4444', fontFamily: "'Barlow', sans-serif", marginBottom: 16 },
  pasoTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: '#141922', marginBottom: 4 },
  pasoSub: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", marginBottom: 20 },
  previewWrap: { display: 'flex', alignItems: 'center', gap: 16, background: '#0D1117', borderRadius: 14, padding: '16px 20px', marginBottom: 20 },
  previewEscudo: { width: 56, height: 56, borderRadius: 14, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, color: 'white' },
  previewNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, color: 'white' },
  campo: { marginBottom: 18 },
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8, fontFamily: "'Barlow', sans-serif" },
  labelSmall: { fontSize: 10, fontWeight: 700, color: '#9BA5B7', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6, fontFamily: "'Barlow', sans-serif" },
  input: { width: '100%', padding: '11px 14px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 14, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' },
  coloresGrid: { display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 8, marginBottom: 14 },
  colorPreset: { width: '100%', aspectRatio: '1', borderRadius: 8, cursor: 'pointer' },
  coloresCustomRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 20 },
  colorPickerRow: { display: 'flex', alignItems: 'center', gap: 8 },
  colorPicker: { width: 36, height: 36, border: '1.5px solid #E8ECF4', borderRadius: 8, cursor: 'pointer', padding: 2 },
  colorHex: { fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase' },
  modalidadesGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 },
  modalidadBtn: { padding: '10px', textAlign: 'center', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: "'Barlow', sans-serif", transition: 'all 0.1s' },
  zonasGrid: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  zonaBtn: { padding: '8px 14px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: "'Barlow', sans-serif", transition: 'all 0.1s' },
  planesGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 20 },
  planCard: { borderRadius: 14, padding: '16px 14px', cursor: 'pointer', transition: 'all 0.12s' },
  destacadoBadge: { color: 'white', fontSize: 9, fontWeight: 700, padding: '2px 10px', borderRadius: 20, fontFamily: "'Barlow', sans-serif", display: 'inline-block', marginBottom: 8 },
  planNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, marginBottom: 2 },
  planPrecio: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, color: '#141922', marginBottom: 10 },
  planPeriodo: { fontSize: 11, fontWeight: 400, color: '#9BA5B7' },
  beneficio: { fontSize: 10, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 4, lineHeight: 1.4 },
  seleccionadoBadge: { marginTop: 10, textAlign: 'center', color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 0', borderRadius: 8, fontFamily: "'Barlow', sans-serif" },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnVolver: { padding: '12px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif" },
  btnSiguiente: { width: '100%', padding: '13px', background: '#FF6B1A', border: 'none', borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: 'white', marginTop: 4 },
  btnFinalizar: { padding: '13px', background: '#FF6B1A', border: 'none', borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: 'white' },
  linkVolver: { textAlign: 'center', marginTop: 16, fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", cursor: 'pointer' },
};
